import {EditField, InputFieldsReturn, ProcData} from 'priority-web-sdk';
import {processProcStepResult} from '../../../services/webSdk/proc';
import {startProcedure} from '../../../services/webSdk/service';

export const runCashierBalanceReport = async (): Promise<string> => {
    return await runJournalsProcedure('CASHBAL');
};

const updateCashierBalanceReportFields =
    () =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            switch (field.field) {
                case 1:
                    value = '*';
                    break;
                case 2:
                case 3:
                case 4:
                    value = '';
                    break;
            }

            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };

export const runJournalsProcedure = async (procName: string): Promise<any> => {
    const procRes: ProcData = await startProcedure(procName, 'R');
    return processProcStepResult(procRes, updateCashierBalanceReportFields(), undefined);
};
